"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/state/normal.js